import React, {createContext, useReducer} from 'react';
import FormReducer from "./reducers/FormReducer";
import formInitialState from "./initialStates/formInitialState";

export const GlobalContext = createContext(null);

export const GlobalProvider = ({stores, children, productId, availableMeetingForm, categoryId, initialStoreId}) => {
    const intInitialStoreId = initialStoreId ? parseInt(initialStoreId) : null;
    // For AT version: default to Bratislava store
    const defaultStore = stores.find(store => store.title === 'Bratislava') || stores[0];
    const [state, dispatch] = useReducer(FormReducer, {
        ...formInitialState,
        stores: stores,
        store: intInitialStoreId ? (stores.find(store => store.id === intInitialStoreId) ?? defaultStore) : defaultStore,
        productId: productId,
        categoryId: categoryId,
        availableMeetingForm: availableMeetingForm,
    });
    return (
        <GlobalContext.Provider value={{
            state,
            dispatch,
        }}>
            {children}
        </GlobalContext.Provider>
    );
};
